(function (angular) {
    angular.module('bizPartEngage').controller('core.register', registerController);

    registerController.$inject = ["$rootScope", "core.registerService", "$translate", "core.users.service", "$window", "bizUser"];

    function registerController($rootScope, registerService, $translate, userService, $window, bizUser) {
        var vm = this;
        vm.Register = Register;
        vm.AcceptedConditions = false;
        vm.Roles = [];
        vm.User = {};
        vm.Message = '';
        vm.IsEmailValid = IsEmailValid;
        vm.IsMobileValid = IsMobileValid;
        vm.GenderClick = GenderClick;
        vm.GetGender = GetGender;
               
        vm.MobilePattern = /^\+[0-9]{10,}$/;
        vm.EmailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //much of the code here is for the possibility of use in custom views, that might not be used in the default view (yet)
        
        function Init() {
            if ($rootScope.MiniSettings.Register.OverrideMobilePattern) {
                vm.MobilePattern = $rootScope.MiniSettings.Register.OverrideMobilePattern;
            }
            if ($rootScope.MiniSettings.Register.UserSettings) {
                vm.User.UserSettings = [];
                for (var i = 0; i < $rootScope.MiniSettings.Register.UserSettings.length; i++) {
                    var userSetting = $rootScope.MiniSettings.Register.UserSettings[i];
                    vm.User.UserSettings.push({ Key: userSetting.Key });
                }
            }
            //vm.User.UserSettings = [{ Key: 'Register_CompanySize' }, { Key: 'Register_ContactMe' }]
            userService.GetGenders().then(GetGendersCallback);
            registerService.GetConfiguration().then(GetConfigurationCallback);
            function GetGendersCallback(response) {
                vm.Genders = BizPartCoreHelpers.getResponseValue(response);
            }

            function GetConfigurationCallback(response) {
                vm.Config = BizPartCoreHelpers.getResponseValue(response);
            }

            vm.IsLoggedIn = bizUser.IsLoggedIn();            
        }

        function GenderClick(gender) {
            for (var i = 0; i < vm.Genders.length; i++) {
                vm.Genders[i].checked = vm.Genders[i] === gender;
            }
        }

        function IsMobileValid() {
            if (!$rootScope.MiniSettings.Register.MobileIsMandatory && !vm.User.Mobile) return true;

            if (!vm.User.Mobile) return false;

            return vm.MobilePattern.test(vm.User.Mobile)
        }

        function IsEmailValid() {
            if (!vm.User || !vm.User.Email) return false;
            if (!vm.EmailPattern) return true;

            return vm.EmailPattern.test(vm.User.Email);
        }

        function GetGender() {
            for (var i = 0; i < vm.Genders.length; i++) {
                if (vm.Genders[i].checked) {
                    return vm.Genders[i].SystemName;
                }
            }
            return null;
        }

        function Register()
        {
            var gender = vm.GetGender();

            var isGenderValid = !$rootScope.MiniSettings.Register.GenderIsMandatory || gender;
            var isUnitValid = !$rootScope.MiniSettings.Register.UnitIsMandatory || vm.SelectedUnit;            
            
            vm.ShowValidation = true;            

            if (vm.MyForm.$valid && isGenderValid && isUnitValid && vm.AcceptedConditions == true && !vm.Submitting && !vm.Submitted && !vm.IsLoggedIn) {
                console.log("submitted");

                vm.ShowValidation = false;
                vm.Submitting = true;
                vm.Message = '';

                vm.User.Gender = gender;
                vm.User.IsActive = true;
                vm.User.CultureId = $rootScope.LoggedInUser.CurrentCultureId;
                vm.User.strCulture = $rootScope.Cultures.GetItemByValue('Id', $rootScope.LoggedInUser.CurrentCultureId).CultureCode;

                if (vm.SelectedUnit) {
                    vm.User.Units = [vm.SelectedUnit];
                }


                registerService.CreateUser(vm.User).then(registerSuccess);

                function registerSuccess(response) {
                    vm.Submitted = true;
                    vm.Submitting = false;
                    vm.Success = response.data.Success;

                    if (response.data.Success == true) {
                        $translate('CORE.REGISTER.USERCREATED').then(function (translation) {
                            vm.SuccessMessage = translation || 'Follow the instructions mailed to you in order to verify your email address and select a password.';
                        });
                    }
                    else {
                        vm.Message = response.data.Message;
                    }

                    if ($window.dataLayer) {
                        $window.dataLayer.push({
                            event: 'form.Submit',
                            attributes: {
                                key: 'register-user-form',
                                success: vm.Success
                            },
                        });
                    }
                }
            } else if (vm.IsLoggedIn) {
                vm.Submitted = true;
                vm.Submitting = false;
                vm.Success = false;
                vm.Message = 'You are logged in. Logout and try again.';
            }
        }

        vm.$onInit = Init;
    }
})(window.angular);
